import type { IconData } from '@stacksjs/iconify-core'

export const contentAddFolder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h4l2 2h8v4.875A5.5 5.5 0 0 0 6.59 13H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m13.983 8.525l.017.01a4 4 0 1 1-.062-.035l.004.002zM14 11.25h-1.25V10h-1.5v1.25H10v1.5h1.25V14h1.5v-1.25H14z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentAddFolder
